import { Link } from "react-router-dom";
import { Fuel, Users, Settings2, MapPin } from "lucide-react";

const FALLBACK_IMG = "https://images.pexels.com/photos/33345481/pexels-photo-33345481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function VehicleCard({ vehicle }) {
  return (
    <Link
      to={`/vehicles/${vehicle.id}`}
      data-testid={`vehicle-card-${vehicle.id}`}
      className="group block bg-[#0A111A]/60 backdrop-blur-2xl border border-white/10 rounded-2xl overflow-hidden transition-all hover:-translate-y-1 hover:border-white/20 hover:shadow-[0_8px_32px_rgba(0,0,0,0.4)]"
    >
      <div className="aspect-[16/10] overflow-hidden bg-[#050B14] relative">
        <img
          src={vehicle.image_url || FALLBACK_IMG}
          alt={vehicle.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => { e.currentTarget.src = FALLBACK_IMG; }}
        />
        <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#050B14]/70 border border-white/10 backdrop-blur-md text-slate-200 capitalize">
          {vehicle.category}
        </span>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">{vehicle.brand}</p>
            <h3 className="text-xl font-medium tracking-tight text-white">{vehicle.name}</h3>
          </div>
          <div className="text-right">
            <p className="text-xs text-slate-500">per day</p>
            <p className="text-lg font-medium text-sky-300">₹{vehicle.price_per_day}</p>
          </div>
        </div>
        <div className="flex items-center gap-4 text-xs text-slate-400">
          <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />{vehicle.seats}</span>
          <span className="flex items-center gap-1.5"><Settings2 className="w-3.5 h-3.5" />{vehicle.transmission}</span>
          <span className="flex items-center gap-1.5"><Fuel className="w-3.5 h-3.5" />{vehicle.fuel_type}</span>
          <span className="flex items-center gap-1.5 ml-auto"><MapPin className="w-3.5 h-3.5" />{vehicle.location}</span>
        </div>
      </div>
    </Link>
  );
}
